import _regeneratorRuntime from "/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __getOwnPropSymbols(source)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

  return target;
};

var __async = function __async(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };

    var rejected = function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };

    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };

    step((generator = generator.apply(__this, __arguments)).next());
  });
}; // src/ActiveStorageProvider.tsx


import { useCallback as useCallback2 } from "react"; // src/DirectUploadProvider.tsx

import { useState, useCallback, useRef, useMemo } from "react"; // src/Upload.ts

import * as ActiveStorage from "@rails/activestorage"; // src/helpers.ts

function buildUrl(_ref) {
  var protocol = _ref.protocol,
      host = _ref.host,
      port = _ref.port,
      path = _ref.path;
  if (!host) return path;
  var buildProtocol = protocol ? "".concat(protocol.split(":")[0], "://") : "//";
  var builtPort = port ? ":".concat(port) : "";
  return buildProtocol + host + builtPort + path;
}

function compactObject(obj) {
  var newObj = __spreadValues({}, obj);

  Object.keys(newObj).forEach(function (key) {
    return newObj[key] === void 0 && delete newObj[key];
  });
  return newObj;
} // src/Upload.ts


var _Upload =
/*#__PURE__*/
function () {
  function _Upload(file, options) {
    var _this = this;

    _classCallCheck(this, _Upload);

    this.handleChangeFile = function (upload) {
      _this.options.onChangeFile(_defineProperty({}, _this.id, upload));
    };

    this.handleProgress = function (_ref2) {
      var loaded = _ref2.loaded,
          total = _ref2.total;
      var progress = loaded / total * 100;

      _this.handleChangeFile({
        state: "uploading",
        file: _this.directUpload.file,
        id: _this.id,
        progress: progress
      });
    };

    this.handleSuccess = function (signedId) {
      _this.handleChangeFile({
        state: "finished",
        id: _this.id,
        file: _this.directUpload.file
      });

      return signedId;
    };

    this.handleError = function (error) {
      _this.handleChangeFile({
        state: "error",
        id: _this.id,
        file: _this.directUpload.file,
        error: error
      });

      throw error;
    };

    this.options = __spreadValues(__spreadValues({}, _Upload.defaultOptions), compactObject(options));
    this.directUpload = new ActiveStorage.DirectUpload(file, this.directUploadsUrl, this);
    this.handleChangeFile({
      state: "waiting",
      id: this.id,
      file: file
    });
  }

  _createClass(_Upload, [{
    key: "start",
    value: function start() {
      var _this2 = this;

      var promise = new Promise(function (resolve, reject) {
        _this2.directUpload.create(function (error, attributes) {
          if (error) reject(error);else resolve(attributes.signed_id);
        });
      });
      return promise.then(this.handleSuccess).catch(this.handleError);
    }
  }, {
    key: "directUploadWillCreateBlobWithXHR",
    value: function directUploadWillCreateBlobWithXHR(xhr) {
      var _a, _b;

      this.addHeaders(xhr);
      (_b = (_a = this.options).onBeforeBlobRequest) == null ? void 0 : _b.call(_a, {
        id: this.id,
        file: this.directUpload.file,
        xhr: xhr
      });
    }
  }, {
    key: "directUploadWillStoreFileWithXHR",
    value: function directUploadWillStoreFileWithXHR(xhr) {
      var _a, _b;

      (_b = (_a = this.options).onBeforeStorageRequest) == null ? void 0 : _b.call(_a, {
        id: this.id,
        file: this.directUpload.file,
        xhr: xhr
      });
      xhr.upload.addEventListener("progress", this.handleProgress);
    }
  }, {
    key: "addHeaders",
    value: function addHeaders(xhr) {
      var headers = this.options.headers;

      if (headers) {
        for (var _i = 0, _Object$keys = Object.keys(headers); _i < _Object$keys.length; _i++) {
          var headerKey = _Object$keys[_i];
          xhr.setRequestHeader(headerKey, headers[headerKey]);
        }
      }
    }
  }, {
    key: "id",
    get: function get() {
      return "".concat(this.directUpload.id);
    }
  }, {
    key: "directUploadsUrl",
    get: function get() {
      var _this$options = this.options,
          origin = _this$options.origin,
          directUploadsPath = _this$options.directUploadsPath;
      return buildUrl(__spreadProps(__spreadValues({}, origin), {
        path: directUploadsPath
      }));
    }
  }]);

  return _Upload;
}();

_Upload.CONVENTIONAL_DIRECT_UPLOADS_PATH = "/rails/active_storage/direct_uploads";
_Upload.defaultOptions = {
  origin: {},
  directUploadsPath: _Upload.CONVENTIONAL_DIRECT_UPLOADS_PATH
};
var Upload = _Upload;
var Upload_default = Upload; // src/DirectUploadProvider.tsx

import { Fragment, jsx } from "react/jsx-runtime";

function useDirectUpload(_ref3) {
  var _this3 = this;

  var directUploadsPath = _ref3.directUploadsPath,
      headers = _ref3.headers,
      _ref3$origin = _ref3.origin,
      origin = _ref3$origin === void 0 ? {} : _ref3$origin,
      onBeforeBlobRequest = _ref3.onBeforeBlobRequest,
      onBeforeStorageRequest = _ref3.onBeforeStorageRequest,
      onSuccess = _ref3.onSuccess;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      uploading = _useState2[0],
      setUploading = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      fileUploads = _useState4[0],
      setFileUploads = _useState4[1];

  var uploads = useRef([]);
  var handleChooseFiles = useCallback(function (files) {
    var _uploads$current;

    if (uploading) return;
    setFileUploads({});
    uploads.current = [];

    (_uploads$current = uploads.current).push.apply(_uploads$current, _toConsumableArray(Array.from(files).map(function (file) {
      return new Upload_default(file, {
        directUploadsPath: directUploadsPath,
        headers: headers,
        onBeforeBlobRequest: onBeforeBlobRequest,
        onBeforeStorageRequest: onBeforeStorageRequest,
        onChangeFile: function onChangeFile(fileUploads2) {
          return setFileUploads(function (prevFileUploads) {
            return __spreadValues(__spreadValues({}, prevFileUploads), fileUploads2);
          });
        },
        origin: origin
      });
    })));
  }, [uploading, directUploadsPath, headers, origin, onBeforeBlobRequest, onBeforeStorageRequest]);
  var handleBeginUpload = useCallback(function () {
    return __async(_this3, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var signedIds;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!uploading) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              setUploading(true);
              _context.next = 5;
              return Promise.all(uploads.current.map(function (upload) {
                return upload.start();
              }));

            case 5:
              signedIds = _context.sent;
              onSuccess(signedIds);
              uploads.current = [];
              setUploading(false);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  }, [onSuccess, uploading]);
  var handleUpload = useCallback(function (files) {
    handleChooseFiles(files);
    return handleBeginUpload();
  }, [handleChooseFiles, handleBeginUpload]);
  return {
    handleChooseFiles: handleChooseFiles,
    handleBeginUpload: handleBeginUpload,
    handleUpload: handleUpload,
    ready: !uploading,
    uploads: useMemo(function () {
      return Object.values(fileUploads);
    }, [fileUploads])
  };
}

var DirectUploadProvider = function DirectUploadProvider(_ref4) {
  var render = _ref4.render,
      onSuccess = _ref4.onSuccess,
      _ref4$origin = _ref4.origin,
      origin = _ref4$origin === void 0 ? {} : _ref4$origin,
      headers = _ref4.headers,
      directUploadsPath = _ref4.directUploadsPath,
      onBeforeBlobRequest = _ref4.onBeforeBlobRequest,
      onBeforeStorageRequest = _ref4.onBeforeStorageRequest;
  var renderProps = useDirectUpload({
    directUploadsPath: directUploadsPath,
    headers: headers,
    origin: origin,
    onBeforeBlobRequest: onBeforeBlobRequest,
    onBeforeStorageRequest: onBeforeStorageRequest,
    onSuccess: onSuccess
  });
  return (
    /* @__PURE__ */
    jsx(Fragment, {
      children: render(renderProps)
    })
  );
};

var DirectUploadProvider_default = DirectUploadProvider; // src/csrfHeader.ts

function getToken() {
  var meta = document.querySelector("meta[name=\"csrf-token\"]");
  return meta && meta.getAttribute("content");
}

function csrfHeader() {
  var token = getToken();
  return token ? {
    "x-csrf-token": token
  } : {};
} // src/ActiveStorageProvider.tsx


import { jsx as jsx2 } from "react/jsx-runtime";

var ActiveStorageProvider = function ActiveStorageProvider(_a) {
  var _b = _a,
      endpoint = _b.endpoint,
      _b$headers = _b.headers,
      headers = _b$headers === void 0 ? {} : _b$headers,
      onSubmit = _b.onSubmit,
      onError = _b.onError,
      _b$multiple = _b.multiple,
      multiple = _b$multiple === void 0 ? false : _b$multiple,
      restProps = __objRest(_b, ["endpoint", "headers", "onSubmit", "onError", "multiple"]);

  var _hitEndpointWithSignedIds = useCallback2(function (signedIds) {
    return __async(void 0, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var protocol, host, port, path, method, attribute, model, body, response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              protocol = endpoint.protocol, host = endpoint.host, port = endpoint.port, path = endpoint.path, method = endpoint.method, attribute = endpoint.attribute, model = endpoint.model;
              body = _defineProperty({}, model.toLowerCase(), _defineProperty({}, attribute, multiple ? signedIds : signedIds[0]));
              _context2.next = 4;
              return fetch(buildUrl({
                protocol: protocol,
                host: host,
                port: port,
                path: path
              }), {
                credentials: "same-origin",
                method: method,
                body: JSON.stringify(body),
                headers: new Headers(__spreadValues(__spreadValues({
                  accept: "application/json",
                  "content-type": "application/json"
                }, csrfHeader()), headers))
              });

            case 4:
              response = _context2.sent;

              if (response.ok) {
                _context2.next = 7;
                break;
              }

              throw response;

            case 7:
              return _context2.abrupt("return", response.json());

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  }, [endpoint, multiple, headers]);

  var handleSuccess = useCallback2(function (ids) {
    return __async(void 0, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      var data;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(ids.length === 0)) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              _context3.prev = 2;
              _context3.next = 5;
              return _hitEndpointWithSignedIds(ids);

            case 5:
              data = _context3.sent;
              onSubmit(data);
              _context3.next = 12;
              break;

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](2);

              if (_context3.t0 instanceof Response) {
                onError == null ? void 0 : onError(_context3.t0);
              }

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 9]]);
    }));
  }, [onSubmit, onError, _hitEndpointWithSignedIds]);
  return (
    /* @__PURE__ */
    jsx2(DirectUploadProvider_default, __spreadProps(__spreadValues({}, restProps), {
      headers: headers,
      origin: {
        host: endpoint.host,
        port: endpoint.port,
        protocol: endpoint.protocol
      },
      onSuccess: handleSuccess
    }))
  );
};

var ActiveStorageProvider_default = ActiveStorageProvider;
export { DirectUploadProvider_default as DirectUploadProvider, Upload_default as Upload, ActiveStorageProvider_default as default, useDirectUpload };